<!-- <nb-card>
    <nb-card-header>Selected Option: {{ option }}</nb-card-header>
    <nb-card-body> --> 
        <!-- <div class="nb-theme-default"> -->
<nb-radio-group [(ngModel)]="option" 
(ngModelChange)="sendValue($event)"
[status]="status"
[disabled]="disableall">
<nb-radio
    *ngFor="let option of options"
    [checked]="option.checked"
    [disabled]="option.disabled"
    [value]="option.value">
    {{ option.label }}
</nb-radio>
</nb-radio-group>
<!-- </div> -->
    <!-- </nb-card-body>
  </nb-card> -->
